<layout-default>
    <div header>
        <div toolbar>
            <h4>
                <i-feather name="sliders"></i-feather> {{'Vehicle types' | translate}}
            </h4>
        </div>

        <div toolbar>
            <button class="btn btn-sm btn-uppercase btn-white"
                [routerLink]="['../create']">
                <i-feather [style.height.px]="23" [style.width.px]="13" class="mg-r-10" name="plus"></i-feather> {{ 'Add new vehicle type' | translate }}
            </button>
            <div id="vehicle-types-btn-search" class="filter-container">
                <div class="phrase-filter">
                    <input type='text' class="list-filter form-control" placeholder="{{'type to search' | translate}}" (keyup)='applyFiltering($event)'/>
                </div>
            </div>
        </div>
        <hr />
    </div>
    
    <div content>
        <div *ngIf="(list$ | async) as list">

            <ngx-datatable 
                id="vehicle-type-table" 
                class="bootstrap" 
                [rows]="rows" 
                [columns]="columns" 
                [columnMode]="'flex'"
                [headerHeight]="50" 
                [footerHeight]="50" 
                [messages]="tableMessages" 
                [rowHeight]="'auto'" 
                [externalPaging]="true"
                [count]="list.totalElements"
                [offset]="queryParams.page"
                [rowClass]="rowClass"
                [limit]="queryParams.size"
                [scrollbarH]="scrollBarHorizontal"
                (sort)="onSort($event)"
                (page)="setPage($event)">
                <ng-container *ngFor="let col of columns">
                    <ngx-datatable-column [name]="col.prop" [flexGrow]="col.flexGrow" [prop]="col.prop" [sortable]="col.sortable">
                        <ng-template let-column="column" ngx-datatable-header-template class="header" let-sort="sortFn">
                            <b (click)="sort()">{{ col.name | translate }}</b>
                        </ng-template>
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

                            <div [ngSwitch]="col.prop">
                                
                                <div id="vehicle-type-table-col-{{col.id}}" *ngSwitchCase="'status'">
                                    <ng-container [ngSwitch]="value">
                                        <span *ngSwitchCase="'NOT_AVAILABLE'" class="badge badge-danger">{{ 'RlmStatus.'+value | translate }}</span>
                                        <span *ngSwitchCase="'AVAILABLE'" class="badge badge-success">{{ 'RlmStatus.'+value | translate }}</span>
                                        <span *ngSwitchDefault class="badge badge-info">{{ 'RlmStatus.'+value | translate }}</span>
                                    </ng-container>
                                </div>
                                <div *ngSwitchCase="'options'">
                                    <div class="dropdown" dropdown>
                                        <button
                                            class="btn btn-outline-secondary btn-xs dropdown-toggle"
                                            type="button"
                                            id="dropdownMenuButton">
                                            {{ 'Select' | translate }}
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right div-main-actions">
                                            
                                            <a 
                                                id="vehicle-type-btn-show-details"
                                                class="btn btn-outline-secondary btn-sm btn-uppercase dropdown-item" 
                                                [routerLink]="['../', row.id]">
                                                    {{'Edit' | translate }}
                                            </a>
    
                                            <!-- <a 
                                                id="vehicle-type-btn-remove"
                                                class="btn btn-outline-secondary btn-sm btn-uppercase dropdown-item" 
                                                (click)="remove(row.id)">
                                                    {{'Remove' | translate }}
                                            </a> -->

                                        </div>
                                    </div>
                                </div>

                                <div id="vehicle-type-table-col-{{col.id}}" *ngSwitchCase="'active'">
                                    <ng-container [ngSwitch]="value">
                                        <span *ngSwitchCase="true" class="badge badge-success">{{ 'ACTIVE' | translate }}</span>
                                        <span *ngSwitchCase="false" class="badge badge-danger">{{ 'UNACTIVE' | translate }}</span>
                                        <span *ngSwitchDefault class="badge badge-info">{{ value }}</span>
                                    </ng-container>
                                </div>
                                <div id="vehicle-type-table-col-{{col.id}}" *ngSwitchDefault>{{ value }}</div>
                            </div>

                        </ng-template>
                    </ngx-datatable-column>
                </ng-container>
            </ngx-datatable>
        </div>

        <div *ngIf="loader" class="load-spinner text-center">
            <i class="fa fa-spinner fast-pulse" aria-hidden="true"></i> {{ 'Please, wait!' | translate }}
        </div>
    </div>

</layout-default>

<ng-template #confirmation>
    <div class="modal-header">
        <h4 class="modal-title">{{'Confirm action' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="decline()"><span aria-hidden="true">&times;</span></button>
    </div>

    <div class="modal-body text-center">
        <p>{{'Do you confirm remove the APM' | translate }}?</p>
        <button type="button" class="btn btn-brand-01" (click)="confirm()">
            {{'Yes, remove' | translate }}
        </button>
        <button type="button" class="btn btn-default" (click)="decline()">{{'Cancel' | translate }}</button>
    </div>
</ng-template>